import React, { FC } from 'react';

import { CompanyData, Maybe } from 'interfaces/graphql-typings';
import { StyleProps } from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';

import styles from 'buyside/components/presentation/IdeaShowPage/RightSidebar/PositionInformation/positionInformationStyles.scss';

const BasicInformation: FC<StyleProps & {
  companyData: Maybe<Pick<CompanyData, 'id' | 'country' | 'geography' | 'industry' | 'sector'>>;
}> = ({ companyData, dataStyle, labelStyle }) => {
  const { sector, country, geography, industry } = companyData || {};
  return (
    <table className={styles.table}>
      <tbody>
        <tr>
          <td>
            <div className={labelStyle}>Sector</div>
            <div className={dataStyle}>{sector || 'N/A'}</div>
          </td>
          <td>
            <div className={labelStyle}>Industry</div>
            <div className={dataStyle}>{industry || 'N/A'}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div className={labelStyle}>Region</div>
            <div className={dataStyle}>{geography || 'N/A'}</div>
          </td>
          <td>
            <div className={labelStyle}>Country</div>
            <div className={dataStyle}>{country || 'N/A'}</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default BasicInformation;
